var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[(_vm.messageData && _vm.messageData.length)?_vm._l((_vm.messageData),function(item,index){return _c('div',{key:index},[_c('chat-content-history',{key:item.id,attrs:{"history-message":item}})],1)}):[_c('no-data',[_vm._v(_vm._s(_vm.$t('message.暂无消息')))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }